<button
  [matMenuTriggerFor]="menu"
  mat-icon-button
  class="action-menu-button"
  [class.action-menu-button--small]="size() === 'small'"
  [attr.data-testid]="testId() ? testId() + '-action-menu' : null"
>
  <fa-icon [icon]="orientation() === 'horizontal' ? faEllipsis : faEllipsisVertical"></fa-icon>
</button>
<mat-menu #menu="matMenu">
  <ng-content select="[slot=menuItems]"></ng-content>
</mat-menu>
